import React from 'react';
import '../../css/about/About.css';
import img5 from '../../img/about/5.jpg';
import img6 from '../../img/about/6.jpg';
import waltImage from '../../img/about/walt.jpg';
import saymaImage from '../../img/about/sayma.jpg';
import elisaImage from '../../img/about/elisa.jpeg';
import belenImage from '../../img/about/belen.jpg';
import tiffanyImage from '../../img/about/tiffany.png';

const About = () => {
  return (
    <div className="about-page">
      {/* Mission & Vision Section */}
      <section className="mission-section">
        <div className="mission-content">
          <div className="mission-text">
            <h1>Built to Unlock the Full Value of College Students</h1>
            <p className="subhead">
              We believe college students are the most underestimated, undervalued engine in the marketing world, and we're here to change that.
            </p>
            <div className="mission-body">
              <p>
                Romulus Media exists to connect brands with college students in a way that creates real value for both. Our mission is simple: to help brands grow by empowering students.
              </p>
              <p>
                Romulus has grown into a national network of <b>over 2,500 vetted student reps across 145+ campuses: powered by data, fueled by trust, and designed for scale.</b>
              </p>
              <p>
                Whether you're looking to run an ambassador program, gather insights through surveys, or source scalable UGC, Romulus Media gives you access to the student world like no one else can.
              </p>
            </div>
          </div>
          <div 
            className="mission-image"
            style={{ backgroundImage: `url(${img5})` }}
          ></div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="values-section">
        <h2 className="section-title">Our Core Values</h2>
        <div className="values-grid">
          <div className="value-card">
            <h3>Radical Honesty</h3>
            <p>We speak clearly, directly, and with integrity. We believe in being concise and transparent.</p>
          </div>
          <div className="value-card">
            <h3>Default to Positivity</h3>
            <p>We choose optimism: we face challenges with confidence and a positive mindset.</p>
          </div>
          <div className="value-card">
            <h3>Clean Communication</h3>
            <p>No confusion. We run on clarity and consistency.</p>
          </div>
          <div className="value-card">
            <h3>Bet on Ourselves</h3>
            <p>We trust our instincts and move with purpose. We take bold actions, guided by confidence in our judgment.</p>
          </div>
        </div>
      </section>

      {/* Team & Values Section */}
      <section className="team-values-section">
        <div className="team-values-content">
          <div 
            className="team-values-image"
            style={{ backgroundImage: `url(${img6})` }}
          ></div>
          <div className="team-values-text">
            <h2 className="about-section-title">Built by Students, Led by Values</h2>
            <p>
              At Romulus Media, the people matter as much as the product. We're not just building campaigns. We're building leaders.
            </p>
            <p>
              We hire for positivity, honesty, and crystal-clear communication. Those are non-negotiable to ensure efficiency and scalability. 
            </p>
            <p>
              We believe the work we do matters. Not just for our clients, but for the next generation. When Romulus succeeds, it's a win for the young demographic everywhere. It's proof that trust, transparency, and responsibility are key.
            </p>
          </div>
        </div>
      </section>

      {/* Team Spotlight Section */}
      <section className="team-spotlight">
        <h2 className="section-title">Meet some of the Team</h2>
        <div className="team-grid">
          <div className="team-member">
            <div 
              className="member-image"
              style={{ backgroundImage: `url(${waltImage})` }}
            ></div>
            <div className="member-info">
              <h3>Walt Smithers</h3>
              <p className="member-title">Founder & CEO</p>
              <p className="member-bio">
                Leads by empowering others. Walt believes responsibility is the fastest path to growth, and that students, when trusted and trained, can outperform any professional marketing team.
              </p>
            </div>
          </div>
          <div className="team-member">
            <div 
              className="member-image"
              style={{ backgroundImage: `url(${saymaImage})` }}
            ></div>
            <div className="member-info">
              <h3>Sayma Khan</h3>
              <p className="member-title">COO</p>
              <p className="member-bio">
                A wizard of organization and clarity. Sayma joined in 2024 and quickly became the backbone of our operations. She absorbs complexity and delivers clean, efficient systems, while keeping the team grounded and supported. 
              </p>
            </div>
          </div>
          <div className="team-member">
            <div 
              className="member-image"
              style={{ backgroundImage: `url(${elisaImage})` }}
            ></div>
            <div className="member-info">
              <h3>Elisa Nguyen</h3>
              <p className="member-title">Director of Campus Strategy</p>
              <p className="member-bio">
                Started as an ambassador, now leads our largest client-facing program. Elisa embodies the Romulus spirit: high-energy, values-driven, and relentlessly reliable. 
              </p>
            </div>
          </div>
          <div className="team-member">
            <div 
              className="member-image"
              style={{ backgroundImage: `url(${belenImage})` }}
            ></div>
            <div className="member-info">
              <h3>Belen Contreras</h3>
              <p className="member-title">Influencer Marketing and Content Director</p>
              <p className="member-bio">
                After leading a marketing group, The American Marketing Association, at her Alma Mater, San Diego State, Belen now leads our creator network, building scalable funnels for content production and influencer partnerships. She's shaping what Gen Z content ops should look like. 
              </p>
            </div>
          </div>
          <div className="team-member">
            <div 
              className="member-image"
              style={{ backgroundImage: `url(${tiffanyImage})` }}
            ></div>
            <div className="member-info">
              <h3>Tiffany Ye</h3>
              <p className="member-title">Research Intern</p>
              <p className="member-bio">
                Tiffany transforms student insights into real-world opportunities that foster growth. She connects students with meaningful experiences, turning vision into action and community into impact.. 
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;